<template>
  <div class="col-12">
    <div class="tile d-flex flex-row align-items-center mt-0 p-2 py-3 rounded">
      <div class="col-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 text-center mr-2">
        <BaseIcon :width="34" :height="34" :name="trackIcon" />
      </div>
      <div class="col-6" style="
          text-overflow: ellipsis;
          width: 20px !important;
          overflow: hidden;
        ">
        {{ name }}
      </div>
      <div class="col-2 d-text d-sm-none d-xs-none d-md-none d-none d-lg-block d-xl-block">
        {{ trackDate }}
      </div>
      <div class="s-text col-1 d-sm-none d-xs-none d-md-none d-none d-lg-block d-xl-block" v-bind:class="complete">
        {{
          approved == 0
          ? reupload_request
            ? "FILE REQUEST"
            : trackStatus == "Complete"
              ? "Done"
              : "Inprogress"
          : "APPROVED"

        }}
      </div>
      <div class="col-4 col-md-2 col-lg-2 text-right d-flex justify-content-end">
        <button class="b-view d-flex justify-content-center align-items-center mx-2" @click="goToTrack">
          View
          <!-- <img class="mx-1" src="../assets/eye.png" alt="" height="15px" width="15px" /> -->
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    id: Number,
    category: String,
    trackStyle: String,
    mixid: String,
    trackStatus: String,
    timestamp: String,
    reupload_request: Boolean,
    approved: Number,
  },
  methods: {
    goToTrack() {

      if (this.category === 'mastering') {
        this.$router.push({ name: "track-master", params: { id: this.id } });

      } else {
        this.$router.push({ name: "track", params: { id: this.id } });

      }

    },
    formatDate(da) {
      var d = new Date(da),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [month, day, year].join("-");
    },
  },
  computed: {
    trackDate() {
      return this.formatDate(this.timestamp);
    },
    trackIcon() {
      return this.category == "Music"
        ? "music"
        : this.category == "TV and Film"
          ? "film"
          : "speaker";
    },
    complete() {
      return this.approved == 1 || this.trackStatus === "Complete"
        ? "complete"
        : "incomplete";
    },
  },
};
</script>

<style scoped></style>
